<div [style]="setHeight()" [class]="themeService.getTheme()" class="button-container">
    <ng-content/>
</div>
